import React from 'react';

function Comoros(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124085)">
        <mask
          id="mask0_800_124085"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124085)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#5196ED"
          />
          <mask
            id="mask1_800_124085"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124085)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 12V18H36V12H0Z"
              fill="#AF0100"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 6V12H36V6H0Z"
              fill="#F7FCFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V6H36V0H0Z"
              fill="#FECA00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0L21.375 12L0 24V0Z"
              fill="#5EAA22"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.21776 16.5012C8.21776 16.5012 4.18648 15.278 4.32906 11.4492C4.47165 7.62041 8.57642 6.87017 8.57642 6.87017C7.13888 5.94738 1.99499 7.02873 1.83037 11.4492C1.66575 15.8697 6.68495 16.8518 8.21776 16.5012ZM8.33886 9.80901L8.46515 9.1545L7.93018 8.69098L8.66949 8.59549L9.00012 8L9.33075 8.59549L10.0701 8.69098L9.53509 9.1545L9.66138 9.80901L9.00012 9.5L8.33886 9.80901ZM8.46515 11.1545L8.33886 11.809L9.00012 11.5L9.66138 11.809L9.53509 11.1545L10.0701 10.691L9.33075 10.5955L9.00012 10L8.66949 10.5955L7.93018 10.691L8.46515 11.1545ZM8.33886 13.809L8.46515 13.1545L7.93018 12.691L8.66949 12.5955L9.00012 12L9.33075 12.5955L10.0701 12.691L9.53509 13.1545L9.66138 13.809L9.00012 13.5L8.33886 13.809ZM8.33886 15.809L8.46515 15.1545L7.93018 14.691L8.66949 14.5955L9.00012 14L9.33075 14.5955L10.0701 14.691L9.53509 15.1545L9.66138 15.809L9.00012 15.5L8.33886 15.809Z"
              fill="#F7FCFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124085">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Comoros;
